import React, { useState } from 'react';

/**
 * Modal สำหรับแก้ไขข้อมูลก่อนพิมพ์ใบส่งของ
 */
const ShippingLabelEditModal = ({ 
  isOpen, 
  onClose, 
  order, 
  store,
  onSave 
}) => {
  const [formData, setFormData] = useState({
    buyerName: order?.buyerName || '',
    buyerPhone: order?.buyerPhone || '',
    shippingAddress: order?.shippingAddress || '',
    notes: order?.notes || ''
  });

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-4 border-b flex justify-between items-center sticky top-0 bg-white">
          <h3 className="text-lg font-semibold">✏️ แก้ไขข้อมูลก่อนพิมพ์</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            ✕
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6">
          <div className="space-y-4">
            {/* Order Number */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                เลขออเดอร์
              </label>
              <input
                type="text"
                value={order?.orderNumber || ''}
                disabled
                className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
              />
            </div>

            {/* Buyer Name */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                ชื่อ-สกุลผู้รับ <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={formData.buyerName}
                onChange={(e) => handleChange('buyerName', e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder="ชื่อ-สกุลผู้รับ"
              />
            </div>

            {/* Buyer Phone */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                เบอร์โทรผู้รับ <span className="text-red-500">*</span>
                <span className="text-xs text-gray-500 ml-2">(สำหรับ QR Code)</span>
              </label>
              <input
                type="tel"
                value={formData.buyerPhone}
                onChange={(e) => handleChange('buyerPhone', e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder="08X-XXX-XXXX"
              />
              <p className="text-xs text-gray-500 mt-1">
                บริษัทขนส่งสามารถ scan QR Code เพื่อค้นหาลูกค้าได้
              </p>
            </div>

            {/* Shipping Address */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                ที่อยู่จัดส่ง <span className="text-red-500">*</span>
              </label>
              <textarea
                value={formData.shippingAddress}
                onChange={(e) => handleChange('shippingAddress', e.target.value)}
                required
                rows={4}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder="ที่อยู่จัดส่ง"
              />
            </div>

            {/* Notes */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                หมายเหตุ (ถ้ามี)
              </label>
              <textarea
                value={formData.notes}
                onChange={(e) => handleChange('notes', e.target.value)}
                rows={3}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder="หมายเหตุเพิ่มเติม"
              />
            </div>
          </div>

          <div className="flex gap-4 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition-colors"
            >
              ยกเลิก
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg transition-colors"
            >
              💾 บันทึกและพิมพ์
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ShippingLabelEditModal;









